import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, FormField,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import type { ProviderPriceListModel } from '@models/types'

import useSelector from '@hooks/useSelector'
import { generateUrls as generateProviderUrls } from '@hooks/useProvider'

type DefaultState = {
  selectedServiceProductId: number | undefined,
}

const defaultState: DefaultState = {
  selectedServiceProductId: undefined,
}

interface AddProductProps {
  callbacks: {
    showCreateOrEditProviderPriceListItemModal: (payload: object) => void,
  },
  providerPriceList: ProviderPriceListModel,
  unassignedServiceProductIds: number[],
}

const AddProduct = (props: AddProductProps) => {
  const {
    callbacks: {
      showCreateOrEditProviderPriceListItemModal,
    },
    providerPriceList,
    unassignedServiceProductIds,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { selectedServiceProductId } = state

  const serviceProducts = useSelector(reduxState => reduxState.entities.serviceProducts)

  const { editProviderRelationsUrl } = generateProviderUrls({ id: providerPriceList.provider_id })

  if (!unassignedServiceProductIds.length){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        // @ts-expect-error TS2322
        <DashboardModule.Link href={editProviderRelationsUrl}>
          Manage Products
        </DashboardModule.Link>
      )}
      title="Add Products"
    >
      <Box padding="large">
        <FormField label="Available Products">
          <select
            onChange={e => setState({ selectedServiceProductId: Number(e.target.value) })}
            value={selectedServiceProductId}
          >
            <option value="">Please Select...</option>
            {unassignedServiceProductIds.map((serviceProductId) => {
              const serviceProduct = serviceProducts[serviceProductId] || {}
              const { id, title } = serviceProduct

              return (
                <option key={id} value={id}>
                  #{id} - {title}
                </option>
              )
            })}
          </select>
        </FormField>
      </Box>

      <DashboardModule.Footer>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            disabled={!selectedServiceProductId}
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => showCreateOrEditProviderPriceListItemModal({
              providerPriceListItem: {
                hidden: false,
                provider_price_list_id: providerPriceList.id,
                service_product_id: selectedServiceProductId,
              },
            })}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Product
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default AddProduct
